import { AxiosError, AxiosResponse } from 'axios'
import { Context } from '../server-middleware/context'

export interface User {
  avatar: string
  userid: number
  username: string
  usertitle: string
}

const fallback: (userId: number) => User = (userId) => ({
  avatar: '',
  userid: userId,
  username: '',
  usertitle: ''
})

class UserAPI {
  url: string
  context: Context
  cache: {[userId: number]: User | undefined}

  constructor (context: Context) {
    this.context = context
    this.cache = {}
    const host = process.env.app_config_api_host
    this.url = host ? `https://${host}` : 'http://api.dev.insided.com'
  }

  public async getUser (userId: number): Promise<User> {
    if (!userId) {
      return fallback(0)
    }

    const cached = this.cache[userId]
    if (cached) {
      return cached
    }

    try {
      const res: AxiosResponse<User> = await this.context.axios.get(`${this.url}/user/${userId}`)
      this.cache[userId] = res.data
      return res.data
    } catch (e) {
      const err: AxiosError = e
      this.context.logger(err)

      return fallback(userId)
    }
  }
}

export default UserAPI
